import { gql } from 'apollo-boost';
import { useMutation } from '../';

const mutation = gql`
  mutation deleteNpoAnswer(
    $id: Int!,
  ) {
  deleteNpoAnswer(
    id: $id,
  ) {
      success
    }
  }
`;

export function useDeleteNpoReportAnswer() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(mutation, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };
  return { data, isLoading, run };
}
